<template>
  <div class="content">
    <!-- 菜单栏（内嵌App时隐藏） -->
    <app-header bgcolor="#00B25A" :transparent="true" :title="title" back-type="back-app" />
    <div class="bg_img_box top_box">
      <!-- 内容 -->
      <div>
        <div class="detail_content_box">
          <div>请提交以下资料进行审核</div>
          <!-- 进度条 -->
          <div class="progress_box">
            <div class="line_box">
              <div class="progress" :style="`width:${progressWidth}`"></div>
            </div>
            <div class="flexbox pro_list">
              <div class="flexbox pro_item" v-for="(item, index) in progressList" :key="index" @click="swipeTo(index)">
                <div class="flexbox img_box">
                  <img
                    :src="currentIndex >= index ? item.selectIcon : item.icon"
                    :class="currentIndex >= index ? 'imageNow' : 'imageNext'"
                  />
                </div>
                <div class="text">{{ item.text }}</div>
              </div>
            </div>
          </div>
        </div>
        <Swipe
          @change="onSwiper"
          :show-indicators="false"
          :loop="false"
          :initial-swipe="currentIndex"
          class="swiper_box"
          ref="swipeDom"
        >
          <SwipeItem>
            <!-- 家庭卡手机号验证 -->
            <div class="details_box">
              <div class="details_title">
                请准确提交家庭卡手机号及验证码，订单审核通过后，将直接为该手机号开通权益。
              </div>
              <div class="details_content_phone">
                <div class="details_title">手机号码</div>
                <div class="flexbox phone_box">
                  <div class="block_box" @click="phoneAreaFn">+{{ areaCode }}</div>
                  <input
                    type="number"
                    data-type="phone"
                    @input="onChangePhone"
                    @blur="onBlurPhone"
                    :disabled="inputDisable"
                    v-model="phone"
                    class="input_box border_left"
                    placeholder="请输入需要开通家庭卡的手机号"
                  />
                </div>
                <div class="flexbox phone_box">
                  <input
                    id="code"
                    type="number"
                    maxlength="4"
                    v-model="captcha"
                    @blur="onBlurCode"
                    placeholder="请输入验证码"
                    class="input_box border_left"
                    :disabled="inputDisable"
                  />
                  <div class="code_box" @click="onGetCaptcha">
                    <button :class="['btn', hasPhone ? '' : 'btn_disable']" :disabled="!hasPhone || inputDisable">
                      {{ captchaBtnText }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </SwipeItem>
          <SwipeItem>
            <div class="details_box idcard_box">
              <div class="details_title">
                请上传能够证明家庭关系的相关照片，我们承诺绝不外传泄漏，仅做内部审核使用。
              </div>
              <upImg @onScuess="onScuessOne"></upImg>
              <upImg @onScuess="onScuessTwo"></upImg>
            </div>
          </SwipeItem>
          <SwipeItem>
            <!-- 上传签名 -->
            <div class="details_box">
              <div class="details_title">请提供本人手写签名</div>
              <div class="flexbox details_content" data-type="signature" @click="makeSign">
                <div class="flexbox sig_tip" v-if="signUrl === ''">点击签名</div>
                <img v-else :src="signUrl" style="border-radius: 20rpx" />
              </div>
            </div>
          </SwipeItem>
        </Swipe>
      </div>
    </div>
    <div class="flexbox next">
      <div :class="phone && captcha ? '' : 'opacity_box'" v-if="currentIndex === 0" @click="nextFun">下一步</div>
      <div :class="idCardUrl && idCardUrl2 ? '' : 'opacity_box'" v-if="currentIndex === 1" @click="nextFun">下一步</div>
      <div :class="signUrl ? '' : 'opacity_box'" v-if="currentIndex === 2" @click="nextFun">下一步</div>
    </div>
    <!-- 用户签名+承诺书合并 -->
    <makeCommitmentDom
      class="makeCommitment_box"
      @makeSuccess="checkSuccess"
      ref="makeCommitmentDom"
    ></makeCommitmentDom>
  </div>
</template>

<script>
import { Swipe, SwipeItem, Dialog } from 'vant'
import upImg from './component/upImg.vue'
import { mapGetters } from 'vuex'
import { getAccountId } from '@/utils/init/pubs'
import { appUser, BehaviorCaptcha } from '@/utils'
import makeCommitmentDom from './makeCommitment.vue'

export default {
  data() {
    return {
      title: '友邻少年',
      currentIndex: 0,
      canvasHeight: 300,
      canvasWidth: 300,
      progressWidth: '',
      progressList: [
        {
          icon: 'https://img-cdn1.ylyk.com/image/1658304999628_m1658276088000_s3162.jpg',
          selectIcon: 'https://img-cdn1.ylyk.com/image/1658304999628_m1658276088000_s3162.jpg',
          text: '家庭卡手机号'
        },
        {
          icon: 'https://img-cdn1.ylyk.com/image/1658304999628_m1658276088000_s1909.jpg',
          selectIcon: 'https://img-cdn1.ylyk.com/image/1658304999628_m1658276088000_s3697.jpg',
          text: '上传相关证明照片'
        },
        {
          icon: 'https://img-cdn1.ylyk.com/image/1658304999628_m1658276088000_s1996.jpg',
          selectIcon: 'https://img-cdn1.ylyk.com/image/1658304999628_m1658276088000_s3787.jpg',
          text: '手写签名'
        }
      ],
      idCardUrl: '',
      idCardUrl2: '',
      id: null,
      // 验证码
      areaCode: '86',
      phone: '',
      inputDisable: false,
      codeOption: 'userBuySubVipCheck',
      // codeOption: 'toLogin',
      captchaRes: null,
      phoneToast: '请输入正确的手机号',
      captcha: '',
      captchaBtnText: '获取验证码',
      hasPhone: false
    }
  },
  components: {
    Swipe,
    SwipeItem,
    upImg,
    makeCommitmentDom
  },
  computed: {
    ...mapGetters('goods/vip', ['commitmentObj']),
    ...mapGetters('user/login', ['getWXUser', 'user', 'code']),
    signUrl() {
      return this.commitmentObj.signUrl || ''
    },
    goodsId() {
      return this.commitmentObj.goodsId || null
    },
    commitmentUrl() {
      return this.commitmentObj.commitmentUrl || null
    }
  },
  watch: {
    currentIndex(index) {
      this.setProgress(index)
    }
  },
  mounted() {
    // 注册行为验证码
    BehaviorCaptcha.create({
      onpass: this.sendCaptcha
    })
  },
  activated() {
    this.id = this.$route.query.id
    this.areaCode = this.$route.params.code || '86'
  },
  methods: {
    onSwiper(index) {
      this.currentIndex = index
    },
    // 去签名
    makeSign() {
      this.$router.push('subVip-submitSign')
    },
    checkValue() {
      // this.$refs.makeCommitmentDom.makeCommitment();
      // return;
      return new Promise((resolve, reject) => {
        const { id, goodsId, commitmentUrl, idCardUrl, idCardUrl2, signUrl, phone, captcha } = this
        // 首次提交资料时,验证商品ID和承诺书URL
        if (!id && (!goodsId || !commitmentUrl)) {
          Dialog.alert({
            message: '未获取到商品ID,请稍后再试',
            confirmButtonColor: '#00B25A'
          }).then(res => {
            // 未获取到商品ID, 返回商品介绍页重新走流程
            sessionStorage.setItem('submitDetailsReload', '1')
            this.$router.replace('goods')
            reject({ index: 0 })
          })
          return
        }
        if (!phone) reject({ message: this.phoneToast, index: 0 })
        if (!captcha) reject({ message: '请输入短信验证码', index: 0 })
        if (!idCardUrl) reject({ message: '请先上传相关证明照片', index: 1 })
        if (!idCardUrl2) reject({ message: '请先上传相关证明照片', index: 1 })
        if (!signUrl) reject({ message: '请提交手写签名', index: 2 })
        resolve(true)
      })
    },
    nextFun() {
      this.checkValue()
        .then(_ => {
          let { currentIndex } = this
          if (currentIndex >= 2) {
            if (!this.inputDisable) return this.$toast('请输入正确的验证码')
            this.$refs.makeCommitmentDom.makeCommitment()
          } else {
            currentIndex += 1
            this.swipeTo(currentIndex)
          }
        })
        .catch(({ message, index }) => {
          this.swipeTo(index, message)
        })
    },
    checkSuccess() {
      const { id, idCardUrl, idCardUrl2, signUrl, phone, captcha, goodsId, areaCode } = this
      this.$store.commit('goods/vip/saveCommitmentDetails', {
        signUrl,
        idCardUrl2,
        areaCode,
        idCardUrl,
        phone,
        captcha
      })
      if (id) {
        // 重新提交
        this.againSubmit()
      } else {
        this.$router.replace({
          path: `/confirm-order/${goodsId}`,
          query: { paytype: 'goods' }
        })
      }
    },
    // 重新提交申请
    againSubmit() {
      const {
        areaCode: destCountryCode,
        signUrl: evidence3,
        commitmentUrl,
        idCardUrl2: evidence2,
        idCardUrl: evidence1,
        phone: destMobile
      } = this.commitmentObj

      this.$store
        .dispatch('goods/vip/subVipExamineUpdate', {
          commitmentUrl,
          destCountryCode,
          evidence1,
          evidence2,
          evidence3,
          destMobile,
          id: this.id
        })
        .then(res => {
          this.$router.replace({
            path: 'subVip-paySuccess',
            query: {
              id: this.id
            }
          })
        })
    },
    swipeTo(index, message = null) {
      if (message) this.$toast(message)
      this.$refs.swipeDom.swipeTo(index)
    },
    setProgress(i) {
      const rate = 100 / this.progressList.length
      this.progressWidth = (i + 1) * rate + '%'
    },
    // 手机号验证
    onChangePhone() {
      this.hasPhone = false
      const isChina = parseInt(this.areaCode) === 86
      if (isChina ? this.phone.length === 11 : true) {
        this.onBlurPhone()
      }
    },
    onBlurPhone() {
      const isChina = parseInt(this.areaCode) === 86
      if (isChina) {
        const reg = /^1[0-9]{10}$/.test(this.phone)
        if (!reg) {
          this.$toast('请输入正确的手机号')
          this.hasPhone = false
        } else {
          this.hasPhone = true
        }
      } else {
        this.hasPhone = true
      }
    },
    // end
    onScuessOne({ url }) {
      this.idCardUrl = url
    },
    onScuessTwo({ url }) {
      this.idCardUrl2 = url
    },
    // 地区
    phoneAreaFn() {
      if (this.inputDisable) return
      this.$router.push({
        name: 'phone-area',
        params: {
          code: this.areaCode,
          type: 2
        }
      })
    },
    // 验证码
    // 显示行为验证码
    onGetCaptcha() {
      if (this.isWating) {
        return
      }
      this.$store
        .dispatch('goods/vip/checkByDestMobile', {
          destCountryCode: this.areaCode,
          destMobile: this.phone
        })
        .then(res => {
          BehaviorCaptcha.show() // 显示验证码
        })
    },
    // 发送验证码（并接受验证码的批次ID）
    sendCaptcha(res) {
      // 发送提示
      this.captchaBtnText = '60s后重试'
      this.captchaRes = res
      this.setTimer()

      const { ticket, randstr: randStr } = this.captchaRes || {}
      // 获取验证码
      const params = {
        mobileNumber: this.phone,
        areaCode: this.areaCode,
        wxUnionId: appUser.unionId,
        wxOpenId: appUser.openId,
        option: this.codeOption,
        ticket,
        randStr // 行为验证码的结果
      }
      const action = this.$store.dispatch('user/login/getCode', params).then(res => {
        this.$toast('验证码发送成功')
      })
      if (action == null) {
        this.$toast('发送验证码失败，login.getCode 未定义')
      }
    },
    onBlurCode() {
      if (!this.phone) return
      const reg = /^[0-9]{4}$/.test(this.captcha)
      const { ticket, randstr: randStr } = this.captchaRes || {}
      if (!reg || !ticket) {
        this.$toast('请输入正确的验证码')
      } else {
        const { batchID } = this.code
        const params = {
          mobileNumber: this.phone,
          areaCode: this.areaCode,
          verificationCode: this.captcha,
          batchID, // 验证码发生成功后获得
          wxUnionId: appUser.unionId,
          wxOpenId: appUser.openId,
          option: this.codeOption,
          ticket,
          isBrowser: appUser.isBrowser,
          accountId: getAccountId(appUser.isBrowser),
          randStr // 行为验证码的结果
        }
        this.$store.dispatch('goods/vip/checkH5VerificationCodeOnly', params).then(res => {
          // this.$toast('验证成功');
          this.inputDisable = true // 输入框禁用
          // this.checkValue().then((_) => {
          //   this.checkSuccess()
          // })
        })
      }
    },
    setTimer() {
      let s = 60
      this.isWating = true
      const timer = window.setInterval(() => {
        this.captchaBtnText = --s + 's后重试'
        // this.hasPhone = false;
        if (s === 0) {
          this.hasPhone = true
          window.clearInterval(timer)
          this.isWating = false
          this.captchaBtnText = '重新获取'
        }
      }, 1000)
    }
    // 验证码end
  }
}
</script>
<style lang="less" scoped>
/* pages/conponMerge/submitDetails/submitDetails.wxss */
.content {
  position: absolute;
  width: 100%;
  min-height: 100%;
  background-color: #f7f9fb;
  // background-color: red;
  line-height: 1.2;
}
.bg_img_box {
  background-image: url('https://img-cdn1.ylyk.com/image/1658297863588_m1658297761233_s30518.jpg');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.top_box {
  width: 100%;
  height: 7.4rem;
  color: #fff;
}

.detail_content_box {
  position: relative;
  padding: 0.24rem 0.32rem 0;
}
.progress_box {
  position: relative;
  width: 100%;
  height: 2.62rem;
}
.line_box {
  position: absolute;
  width: calc(100% - 90px);
  height: 0.08rem;
  top: 0.8rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 0;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 0.1rem;
  overflow: hidden;
}
.line_box_receive {
  width: calc(100% - 150px);
}
.progress {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  z-index: 10;
  background-color: #fff;
  min-width: 33.33%;
}
.pro_list {
  position: absolute;
  width: 100%;
  left: 0;
  top: 0.46rem;
  z-index: 1;
  align-items: flex-start;
  padding: 0 0 0.48rem;
}
.pro_item {
  flex-direction: column;
  width: calc(100% / 3);
  font-size: 0.28rem;
  font-weight: 500;
  padding: 0 0.3rem;
}
.pro_item_receive {
  width: calc(100% / 2);
}
.pro_item .text {
  margin-top: 0.1rem;
}
.pro_item .img_box {
  width: 0.8rem;
  height: 0.8rem;
  justify-content: center;
}
.pro_item img {
  display: block;
  border-radius: 50%;
}
.pro_item .imageNow {
  width: 0.8rem;
  height: 0.8rem;
}
.pro_item .imageNext {
  width: 0.6rem;
  height: 0.6rem;
}

/* 资料 */
.swiper_box {
  width: 100%;
  /deep/ .van-swipe__track {
    background: #f7f9fb;
  }
}
.details_box {
  width: 6.86rem;
  background: #ffffff;
  border-radius: 0.16rem;
  margin: 0 auto;
  padding: 0.28rem 0.24rem 13vh;
}
.idcard_box {
  padding: 0.28rem 0.24rem 1rem;
  margin: 0 auto 2rem;
}
.details_title {
  font-size: 0.32rem;
  font-weight: 600;
  color: #000000;
}
.details_content {
  position: relative;
  width: 6.38rem;
  height: 3.82rem;
  background: #f6f6f6;
  border: 1px dashed rgba(0, 102, 102, 0.8);
  border-radius: 0.16rem;
  margin-top: 0.48rem;
  justify-content: center;
  .file_box {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0;
  }
}

.details_content img {
  display: block;
  width: 5.02rem;
  height: 3.06rem;
}

.next {
  position: fixed;
  left: 0;
  z-index: 10;
  bottom: 0;
  width: 100%;
  background: #ffffff;
  box-shadow: 0rpx -4px 0.2rem 0rpx rgba(0, 0, 0, 0.06);
  padding: 0.32rem 0 0.5rem;
}
.next div {
  width: 6.54rem;
  height: 0.88rem;
  background: #00b25a;
  border-radius: 0.08rem;
  box-shadow: 0rpx -4px 0.2rem 0rpx rgba(0, 0, 0, 0.06);
  margin: 0 auto;
  line-height: 0.88rem;
  text-align: center;
  font-size: 0.32rem;
  font-weight: 600;
  color: #ffffff;
}
.opacity_box {
  opacity: 0.3;
}

.details_content_phone {
  color: #000;
  padding-top: 0.48rem;
}

.phone_box {
  width: 6.38rem;
  height: 0.88rem;
  border: 1px solid #00b25a;
  border-radius: 0.1rem;
  margin-top: 0.2rem;
  .input_box {
    border: none;
    outline: 0;
  }
  .code_box {
    flex-shrink: 0;
    padding: 0 0.22rem;
    border-left: 1px solid #a5a5a5;
    .btn {
      font-size: 0.28rem;
      background-color: #fff;
    }
    .btn_disable {
      color: #a5a5a5;
    }
  }
}
.phone_box .block_box {
  padding: 0 0.3rem 0 0.24rem;
  position: relative;
  border-right: 1px solid #f7f9fb;
}

.phone_box .block_box::after {
  content: '';
  width: 0px;
  height: 0px;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-left: 6px solid #000;
  transform: rotate(45deg);
  position: absolute;
  bottom: 0px;
  right: 5px;
}

.phone_box input {
  display: block;
  font-size: 0.28rem;
  flex: auto;
  margin-left: 0.2rem;
  -webkit-user-select: text;
  -user-select: text;
}
.phone_box input:disabled {
  background-color: #fff;
}

.sig_tip {
  width: 100%;
  height: 100%;
  font-size: 0.32rem;
  color: #000;
  justify-content: center;
  font-weight: 600;
}
.makeCommitment_box {
  position: fixed;
  top: 0;
  left: -10000px;
}
</style>
